// src/components/tv/TVFooter.tsx
import React, { FC } from 'react';
import { SchoolEvent } from 'models/event';

interface TVFooterProps {
  events:         SchoolEvent[];
  activeSchoolId: string;
}

const TVFooter: FC<TVFooterProps> = ({ events }) => {
  return (
    <div className="tv-footer">
      {events.map(evt => (
        <div key={evt.id} className="footer-event">
          <span>{evt.generatedNames?.official || '(no name)'}</span>
          <span>{new Date(evt.startTime).toLocaleTimeString()}</span>
        </div>
      ))}
    </div>
  );
};

export default TVFooter;
